'use strict';

var formValidation = require('../components/formValidation');
var notifications = require('../components/notifications');
var location = window.location;

const selectors = {
    loginForm: '.js-login',
    registerForm: '.js-registration',
    reCaptchaTokenFieldLogin: '.js-gCaptchaToken-login',
    reCaptchaTokenFieldRegister: '.js-gCaptchaToken-register',
    resetPasswordForm: '.reset-password-form',
    requestPasswordTitle: '.request-password-title',
    requestPasswordBody: '.request-password-body',
    submitEmailBtn: '#submitEmailButton',
    sendEmailBtn: '.send-email-btn',
    loginSubmitBtn: '.js-login-submit',
    registerSubmitBtn: '.js-register-submit',
    customerTypeRadio: '.js-register-customer-type',
    companyField: '.js-company-field',
    individualField: '.js-individual-field',
    companyNameInput: '.js-register-company-name',
    siretInput: '.js-register-siret',
    invoicingElectronicAddressInput: '.js-register-invoicing-electronic-address, .js-address-invoicing-electronic-address',
    emailConfirmInput: '.js-email-confirm',
    emailOptinCheckbox: '.js-register-email-optin',
    trackingConsentField: '.js-register-tracking-consent'
};

const COMPANY_VALUE = 'company';

/**
 * Toggle company-specific fields based on selected customer type
 * @param {jQuery} $form - The registration form
 * @param {string} selectedValue - The selected customer type value
 */
function toggleCompanyFields($form, selectedValue) {
    var isCompany = selectedValue === COMPANY_VALUE;
    var $companyFields = $form.find(selectors.companyField);
    var $individualFields = $form.find(selectors.individualField);

    if (isCompany) {
        $companyFields.removeClass('d-none');
        // Re-enable before validating: a disabled input is skipped by checkValidity()/serialize().
        $companyFields.find('input').removeAttr('disabled');
        // Only mark fields whose form-group carries the .required marker
        $companyFields.filter('.required').find('input').attr('required', 'required');
        $companyFields.not('.required').find('input').removeAttr('required');
        $individualFields.addClass('d-none');
        $individualFields.find('input').removeAttr('required');
    } else {
        $companyFields.addClass('d-none');
        // Disable hidden inputs: excludes them from validation/POST and from Chrome autofill,
        // which otherwise fills the hidden VAT field with the e-mail and blocks submit.
        $companyFields.find('input').removeAttr('required').attr('disabled', 'disabled');
        $individualFields.removeClass('d-none');
        $individualFields.filter('.required').find('input').attr('required', 'required');
        $individualFields.not('.required').find('input').removeAttr('required');
    }
}

/**
 * Toggle the email tracking consent, which only makes sense once the shopper subscribed.
 * @param {jQuery} $form - The registration form
 */
function toggleTrackingConsent($form) {
    var isSubscribed = $form.find(selectors.emailOptinCheckbox).is(':checked');
    var $trackingField = $form.find(selectors.trackingConsentField);

    if (isSubscribed) {
        $trackingField.removeClass('d-none');
        // Re-enable before validating: a disabled input is skipped by checkValidity()/serialize().
        $trackingField.find('input').removeAttr('disabled');
    } else {
        $trackingField.addClass('d-none');
        // Clear the consent so it cannot survive hidden, then disable the input: this excludes
        // it from the POST and from Chrome autofill, as done for the company fields above.
        $trackingField.find('input').prop('checked', false).attr('disabled', 'disabled');
    }
}

const $cache = {
    alertContainerLogin: $('.js-alert-wrapper-login'),
    alertContainerRegister: $('.js-alert-wrapper-register')
};

/**
 * Submits login form data
 * @param {obj} e Login form submit event object
 * @param {obj} form Login form
 */
function submitLoginForm(e, form) {
    var url = form.attr('action');
    $.spinner().start();
    $(selectors.loginSubmitBtn).attr('disabled', 'disabled');
    $(selectors.loginForm).trigger('login:submit', e);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (!data.success) {
                // Migrated customer logging in
                if (data.migrationRequired && data.redirectUrl) {
                    location.href = data.redirectUrl;
                    return;
                }
                formValidation(form, data);
                $(selectors.loginForm).trigger('login:error', data);
                setTimeout(function(){
                    $(selectors.loginSubmitBtn).attr('disabled', false);
                }, 1000);
                notifications.create(data.error, 'error', $cache.alertContainerLogin);
            } else {
                $(selectors.loginForm).trigger('login:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (data) {
            if (data && data.responseJSON) {
                if (data.responseJSON.redirectUrl) {
                    location.href = data.responseJSON.redirectUrl;
                } else if (data.responseJSON.error) {
                    $(selectors.loginForm).trigger('login:error', data);
                    notifications.create(data.responseJSON.error, 'error', $cache.alertContainerLogin);
                }
            }
            $.spinner().stop();
            setTimeout(function(){
                $(selectors.loginSubmitBtn).attr('disabled', false);
            }, 1000);
        }
    });
}

/**
 * Submits registration form
 * @param {obj} e Register form submit event object
 * @param {obj} form Register form data
 */
function submitRegisterForm(e, form) {
    var url = form.attr('action');
    $(selectors.registerSubmitBtn).attr('disabled', 'disabled');
    $.spinner().start();
    $(selectors.registerForm).trigger('login:register', e);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (!data.success) {
                $(selectors.registerForm).trigger('login:register:error', data);
                formValidation(form, data);
                if (data.error) {
                    notifications.create(data.error, 'error', $cache.alertContainerRegister);
                }
                setTimeout(function(){
                    $(selectors.registerSubmitBtn).attr('disabled', false);
                }, 1000);
            } else {
                $(selectors.registerForm).trigger('login:register:success', data);
                location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                if (err.responseJSON.errorMessage) {
                    notifications.create(err.responseJSON.errorMessage, 'error', $cache.alertContainerRegister);
                }
                setTimeout(function(){
                    $(selectors.registerSubmitBtn).attr('disabled', false);
                }, 1000);
            }
            $.spinner().stop();
        }
    });
}

module.exports = {
    preventInvoicingElectronicAddressPaste: function () {
        // Use delegated binding so it survives ajax-re-rendered forms (checkout shipping/billing).
        $('body').on('paste', selectors.invoicingElectronicAddressInput, function (e) {
            e.preventDefault();
        });
    },
    preventEmailConfirmPaste: function () {
        // Mirror of preventInvoicingElectronicAddressPaste for the contact e-mail confirmation field.
        $('body').on('paste', selectors.emailConfirmInput, function (e) {
            e.preventDefault();
        });
    },
    login: function () {
        $(selectors.loginForm).on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            // If Google reCaptcha is enabled/loaded
            if (window.grecaptcha) {
                // Google reCaptcha Site key
                var gsiteKey = form.data('gsite-key');
                window.grecaptcha.ready(function () {
                    window.grecaptcha.execute(gsiteKey, {action: form.data('action')})
                        .then(function (token) {
                            form.find(selectors.reCaptchaTokenFieldLogin).val(token);
                            submitLoginForm(e, form);
                        });
                });
            } else {
                submitLoginForm(e, form);
            }
        });
    },
    customerTypeToggle: function () {
        var $registerForm = $(selectors.registerForm);
        $registerForm.on('change', selectors.customerTypeRadio, function () {
            toggleCompanyFields($(this).closest(selectors.registerForm), $(this).val());
        });
        // Apply the initial state on load, defaulting to individual (the ISML default) so hidden
        // company fields start disabled before any type is chosen.
        var $checked = $registerForm.find(selectors.customerTypeRadio + ':checked');
        toggleCompanyFields($registerForm, $checked.length ? $checked.val() : 'individual');
    },
    trackingConsentToggle: function () {
        var $registerForm = $(selectors.registerForm);
        $registerForm.on('change', selectors.emailOptinCheckbox, function () {
            toggleTrackingConsent($(this).closest(selectors.registerForm));
        });
        // Apply the initial state on load so the consent starts hidden and disabled.
        toggleTrackingConsent($registerForm);
    },
    register: function () {
        $(selectors.registerForm).submit(function (e) {
            var form = $(this);
            e.preventDefault();
            // If Google reCaptcha is enabled/loaded
            if (window.grecaptcha) {
                // Google reCaptcha Site key
                var gsiteKey = form.data('gsite-key');
                window.grecaptcha.ready(function () {
                    window.grecaptcha.execute(gsiteKey, {action: form.data('action')})
                        .then(function (token) {
                            form.find(selectors.reCaptchaTokenFieldRegister).val(token);
                            submitRegisterForm(e, form);
                        });
                });
            } else {
                submitRegisterForm(e, form);
            }
        });
    },
    resetPassword: function () {
        $(selectors.resetPasswordForm).submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(selectors.requestPasswordTitle).text(data.receivedMsgHeading);
                        $(selectors.requestPasswordBody).empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $(selectors.submitEmailBtn).text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $(selectors.sendEmailBtn).empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-secondary">'
                                    + data.buttonText + '</a>');
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
            return false;
        });
    },
};
